<template>
    <div class="tables theme-card" ref="tableContainer">
        <div class="widget-loading-indicator" v-if="loading">
            <LoadingIndicator v-if="loading" message="Loading Accounts"/>
        </div>
        <div v-if="!loading" class="table-header">
                <div class="table-title">Job Seekers Accounts</div>
            </div>
            <div class="table-content">

                        <div v-if="!loading" class="table-tools" style="display:flex;justify-content: space-between;align-items:center;">
                                <div class="table-actions">
                                    <button type="button" class="search-btn" :disabled="searchBtnClicked" @click="loadInitPageForSearch">
                                        <SearchIcon/>
                                    </button>
                                    <input type="text" v-model="searchBody.search"  class="search-query" placeholder="Search Users" @keyup.enter="loadInitPageForSearch">
                                    <button type="button" class="search-btn" :disabled="cancelBtnClicked" style="background:var(--background)!important;color:var(--page-header)!important;margin-left:0.5rem;" v-if="isSearch" @click="loadInitPage">
                                        <CloseIcon/>
                                    </button>
                                </div>  
                                    <!-- <button class="delete-all" @click="showDeleteAllOptions" :disabled="deleteAllBtnClicked">
                                    
                                        <span style="font-size:0.9rem;">{{ deleteAllBtnClicked == true ? 'Deleting...' : 'Delete All' }}</span></button> -->
                        </div>


                    <table v-if="!loading" id="myTable" class="display">
                        <thead>
                            <tr>
                                <th>Full Name</th>
                                <th>Email Address</th>           
                                <th>Phone</th>
                                <th>Join Date</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th> <!-- icon buttons here -->
                            </tr>
                        </thead>
                        <tbody>
                            <!-- item -->
                            <!-- <tr> -->
                            <tr v-for="account in accounts">
                                <td :title="account.fullName"><div class="row-context">{{account.fullName}}</div></td>
                                <td :title="account.email"><div class="row-context">{{account.email}}</div></td> 
                                <td :title="account.phone"><div class="row-context">{{account.phone}}</div></td> 
                                <td :title="account.joinDate"><div class="row-context">{{ account.joinDate }}</div></td> 
                                <td></td> 
                                <td>
                                    <div class="icon-buttons">
                                        <button :disabled="account.emailConfirmed" @click="confirmEmail(account)" title="Confirm Account Email Address" class="btn btn-default btn-sm icon-button confirm">
                                            <CheckCircleIcon class="icon-button-icon"/>
                                            <div class="icon-text">Confirm Email</div>
                                        </button>
                                          <button :disabled="!account.subscriptionExpired" @click="renewSubscription(account)" :enab title="Restart Account Subscription" class="btn btn-default btn-sm icon-button restart">
                                             <RefreshIcon class="icon-button-icon"/>
                                            <div class="icon-text">Restart Subscription</div>
                                        </button>
                                        <button @click="toggleActivate(account)" :ref="account.id+'active'" v-if="account.isActive" title="Dectivate Account" style="background-color: var(--orange);" class="btn btn-default btn-sm icon-button">
                                             <ZapOffIcon class="icon-button-icon"/>
                                            <div class="icon-text">Deactivate</div>
                                        </button> 
                                        <button @click="toggleActivate(account)" v-else title="Activate Account" class="btn btn-default btn-sm icon-button activate">
                                             <ZapIcon class="icon-button-icon"/>
                                            <div class="icon-text">Activate</div>
                                        </button> 
                                        <button @click="toggleAuthorization(account)" v-if="account.isUnauthorized" title="Restore Account" class="btn btn-default btn-sm icon-button activate">
                                             <CheckCircleIcon class="icon-button-icon"/>
                                            <div class="icon-text">Restore</div>
                                        </button>
                                         <button @click="toggleAuthorization(account)" v-else title="Suspend Account" class="btn btn-default btn-sm icon-button suspend">
                                             <SlashIcon class="icon-button-icon"/>
                                            <div class="icon-text">Suspend</div>
                                        </button>
                                      
                                        
                                    </div>
                                </td>
                            </tr>

                        
                            <!--  -->

                        </tbody>
                    </table>
                    <div v-if="!loading" class="custom-pagination" style="margin-top:2rem;">
                            <button class="btn btn-default btn-sm pager-btn" :disabled="currentPage === 1" @click="prevPage">Prev</button>
                            <button class="btn btn-default btn-sm pager-btn" :disabled="accounts.length < 20" @click="nextPage">Next</button>
                    </div>  

            </div>
    </div>
    <ToastMessage 
        ref="applicantToast"
        :message="toast.message"
        :success="toast.success"/>
     <WarningOptionsModal
            ref="delApplicant"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting Applicant..."
            />
    <WarningOptionsModal
            ref="delAllApp"
            :body="this.delAllModal.body"
            :title="this.delAllModal.title"
            :close-modal="this.closeDelAllModal"
            :yes-selected="this.deleteAll"
            :yes-button-label="this.delAllModal.yesButtonLabel"
            :no-button-label="this.delAllModal.noButtonLabel"
            :modal-id="this.delAllModal.modalId"
            loading-button-label="Deleting All Vacancies..."
            />
    <!-- <PreviewApplicantModal :applicant="previewedApplicant"
                        :toggle-shortlist="toggleShortlistFromPreview"
                        :set-for-delete="setForDeleteFromPreview"
                        ref="previewApplicant"
                        modal-id="previewApplicant"/> -->
</template>
<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import TrashIcon from '@/components/IconComponents/TrashIcon.vue';
import CloseIcon from '@/components/IconComponents/CloseIcon.vue';
import SearchIcon from '@/components/IconComponents/SearchIcon.vue';
import UserCheckIcon from '@/components/IconComponents/UserCheckIcon.vue';
import CheckmarkIcon from '@/components/IconComponents/CheckmarkIcon.vue';
import DataTable from 'datatables.net-dt';  
import ToastMessage from '@/components/modals/ToastMessage.vue'
import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
import InfoIcon from '@/components/IconComponents/InfoIcon.vue';
// import PreviewApplicantModal from '@/components/modals/PreviewApplicantModal.vue';
import ZapIcon from '@/components/IconComponents/ZapIcon.vue';
import ZapOffIcon from '@/components/IconComponents/ZapOffIcon.vue';
import SlashIcon from '@/components/IconComponents/SlashIcon.vue';
import RefreshIcon from '@/components/IconComponents/RefreshIcon.vue';
import CheckCircleIcon from '@/components/IconComponents/CheckCircleIcon.vue';
import { confirmEmailAsync, renewSubscriptionAsync, toggleActivationAsync, toggleAuthorizationAsync } from '@/services/admin/adminService';
export default {
    components:{
        LoadingIndicator, 
        TrashIcon, 
        CloseIcon, 
        SearchIcon, 
        UserCheckIcon, 
        CheckmarkIcon,
        ToastMessage,
        WarningOptionsModal,
        InfoIcon,
        ZapIcon,
        ZapOffIcon,
        RefreshIcon,
        SlashIcon,
        CheckCircleIcon

    },
    computed:{
        accounts(){
            return this.$store.getters["administrator/getAccounts"] || [];       
        },
        
    },
     mounted(){
        this.loadInitPage(1);
        this.table = new DataTable('#myTable', {
                       dom: 'rt',
                       scrollY: 300,
                       scrollCollapse: false,
                       ordering: false,
                       paging: false,
                       searching: false
            });
    },
    data(){
        return {
          
            searchQuery: '',
            table: null,
            currentPage: 1,
            totalPages: 0,
            pagerPages: [],
            pageSize: 20,
            totalRecords: 0,

            loading: true,
            modal:{
                caption:"",
                message:""
            },
            modalButtonLabel:'Close',
            modalId:"jobSeek",
            isSearch:false,
            searchBody:{
                search:""
            },
            delModal:{
                title:"",
                body:"",
                modalId:"delApp",
                yesButtonLabel:"Yes",
                noButtonLabel:"No",
                closeModal: null,
                yesSelected: null
            },
             delAllModal:{
                title:"Delete All Applicants",
                body:"<p><b>WARNING!</b><br/> You are about to permanently delete all your applicants. Note that this is action is irreversible.<p/><p>Are you sure want to permanently delete all your applicants?</p>",
                modalId:"delAllVApp",
                yesButtonLabel:"Delete All",
                noButtonLabel:"Cancel"
            },
            editModal:{
                modalId:"editVac",
                vacancy: null
            },
            searchBtnClicked: false,
            cancelBtnClicked: false,
            // deleteAllBtnClicked: false,
            toast:{
                message:"",
                success:true
            },
           

        };
    },
    methods:{
        showDeleteAllOptions(){
            this.showDelAllModal();
        },
         async loadInitPage(){ //load the first page upon page visit
            try{
            this.cancelBtnClicked = true; //for when a user cancels search. Just keep it here
            this.currentPage = 1;
            this.isSearch = false;
            this.searchBody.searchTerm = "";
          
                await this.$store.dispatch("administrator/getJobSeekerAccounts", this.currentPage);
                
            this.loading = false;
            this.cancelBtnClicked = false;
            }catch(e){
                console.log(e);
                this.loading = false;
                this.cancelBtnClicked = false;
               
            }
        },
        
         async loadInitPageForSearch(){ //load the first page upon search
            try{
            this.searchBtnClicked = true;
            this.currentPage = 1;
            
            await this.$store.dispatch("administrator/searchJobSeekerAccounts", {
                data: this.searchBody.search,
                page: this.currentPage
            });
            this.isSearch = true;
            this.loading = false;
            this.searchBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.searchBtnClicked = false;
            }
        },
        setForDelete(applicant){
            this.delModal.title = "Delete Applicant",
            this.delModal.body = `<b>WARNING!</b></br>You are about to permanently delete ${applicant.fullname} as an applicant.` +
                                 ` Note that this action is irreversible.<br>`+
                                 `Are you sure you want to permanently delete them as an applicant?</br>`;
            this.delModal.yesSelected = async() => await this.deleteApplicant(applicant);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
        
        async goToPage(page) {
            if(!this.isSearch){ 
                      
               await this.$store.dispatch("administrator/getJobSeekerAccounts", page);
            }else{
                await this.$store.dispatch("administrator/searchJobSeekerAccounts", {
                data: this.searchBody.search,
                page: page
            });
            }
              this.$nextTick(() => {
                    this.$refs.tableContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
        },
          async prevPage() {
            if(this.currentPage > 1){

                await this.goToPage(this.currentPage -= 1);
            }
        },
        async nextPage() {
            await this.goToPage(this.currentPage += 1);
        },
        closeDelAllModal(){
            this.$refs.delAllApp.hide();
        },
          async deleteAll(){
             try{
            this.closeDelAllModal();
            this.deleteAllBtnClicked = true;
            await this.$store.dispatch("jobApplicants/deleteAllJobApplicantsAsync", this.vacancy.jobId);
            this.deleteAllBtnClicked = false;
             this.toast = {
                    message:"All your applicants have been permanently deleted",
                    success: true
            }
            this.showToastMessage();
            }catch(e){
                this.deleteAllBtnClicked = false;
               this.toast = {
                    message:"Unable to permanently delete all applicants. Please check your connection or try again later",
                    success: false
                }
                this.showToastMessage();
            }
        },
        async toggleActivate(account){
            try{    
                let response = await toggleActivationAsync(account.id);
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    account.isActive = response.isActive;
                    this.$store.dispatch("administrator/updateAccounts", account);
                    let message = response.isActive == true ? `${account.fullName} has been activated`:`${account.fullName} has been deactivated`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = account.isActive == true ? `Failed to deactivate ${account.fullName}. Check your connection or try again later`: `Failed to activate ${account.fullName}. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
                
            }
        },
        async toggleAuthorization(account){
            try{    
                let response = await toggleAuthorizationAsync(account.id);
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    account.isUnauthorized = response.isUnauthorized;
                    this.$store.dispatch("administrator/updateAccounts", account);
                    let message = response.isUnauthorized == true ? `${account.fullName} has been suspended`:`${account.fullName} has been restored`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = account.isUnauthorized == true ? `Failed to restore ${account.fullName}. Check your connection or try again later`: `Failed to suspend ${account.fullName}. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
                
            }
        },
        async confirmEmail(account){
            try{    
                let response = await confirmEmailAsync(account.id);
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    account.emailConfirmed = response.emailConfirmed;
                    this.$store.dispatch("administrator/updateAccounts", account);
                    let message =  `${account.fullName}'s Email Address has been confirmed`;
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = `Failed to confirm ${account.fullName}'s Email Address. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
                
            }
        },
        async renewSubscription(account){
            try{    
                let response = await renewSubscriptionAsync(account.id);
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    account.subscriptionExpired = response.subscriptionExpired;
                    this.$store.dispatch("administrator/updateAccounts", account);
                    let message =  `Successfully restarted ${account.fullName}'s subscription`;
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = `Failed to restart ${account.fullName}'s subscription. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
                
            }
        },
        async deleteApplicant(applicant){
             try{
                 this.closeDelModal();
                let response = await deleteApplicantAsync({
                    applicantId: applicant.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    
                    this.$store.dispatch("jobApplicants/removeAPermanentlyDeletedApplicant", applicant.applicantId);
                    
                    let message = `${applicant.fullname} has been permanently deleted as an Applicant`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = `Failed to delete ${applicant.fullname} as an Applicant. Check your connection or try again later`
                    this.toast = {
                        message: message,
                        success: false
                    }
                    this.showToastMessage();
            }
        },
        showToastMessage(){
             this.$nextTick(() => {
                    this.$refs.applicantToast.show();
                });
        },
        showDelModal(){
            this.$refs.delApplicant.show();
        },
        closeDelModal(){
            this.$refs.delApplicant.hide();
        },
        showDelAllModal(){
            this.$refs.delAllApp.show();
        },
        previewApplicant(applicant){
            this.previewedApplicant = applicant;
            this.$refs.previewApplicant.show();
        },
        toggleShortlistFromPreview(){
            this.$refs.previewApplicant.hide();
            setTimeout(() => this.toggleShortlist(this.previewedApplicant),1000);
        },
        setForDeleteFromPreview(){
            this.$refs.previewApplicant.hide();
            setTimeout(() => this.setForDelete(this.previewedApplicant), 1000);
        }
    }
}
</script>
<style scoped>

.not-selected{
    opacity:0.5;
    color:var(--placeholder);
}

.checkmark-column{
 display: grid;
}

.checkmark-icon{
    justify-self: center;
    margin-top:0.25rem;
    color:var(--green);
}

.hidden-icon{
    opacity:0;
}

.pager-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border:0px;
    background: transparent;
    color: var(--page-header)!important;
    cursor: pointer;
    font-size:0.8rem;
    text-transform:uppercase;
    font-family: var(--heading-font-regular);
}
.pager-btn.current {
    background: var(--primary, var(--primary-color, #007bff));
    color: #fff;
    border-color: var(--primary, var(--primary-color, #007bff));
}
.pager-btn:disabled {
    opacity: 0.5;
    cursor: default;
    color:var(--placeholder)!important;
}
    
.custom-pagination {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 12px;
}

     .icon-buttons{
        display: flex;
        justify-content: right;
    }

    .row-context{
        white-space:nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        max-width:10rem;
    }

     .icon-button{
        padding:0.3rem 0.4rem;
        border:0px;
        display: flex;
        align-items: center;
        margin-left:0.25rem;
        color:var(--enterprise-button);
        border-radius:100px;
    }

    .confirm{
        background:var(--page-header);
    }

    .activate{
        background:var(--green);
    }

    .suspend{
        background:var(--red);
    }

    .restart{
        background:var(--blue);
    }

    .icon-button-icon{
        height:0.9rem;
        margin-top:-0.1rem;
        margin-right:0.1rem;
    }

    .icon-text{
        margin-top: 0.1rem;
        margin-right:0.4rem;
        font-size:0.8rem;
        
    }

.app-table-head{
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
   
}

th{
    flex:1;
}

.table-actions {
    margin-top:0.5rem;
    display: flex;

}


.search-query{
    padding:0.5rem 0.8rem;
    width:25rem;
    margin-bottom:1rem;
}
.table-title {
    font-weight: 600;
    font-size: 18px;
}

.table-header {
    display: flex;
    justify-content: space-between;
}
    .theme-card{
  margin:0rem;
}



.table-content {
    overflow-x: auto;
}

.search-btn{
    height:2.2rem;
    width: 2.2rem;
    background-color: var(--page-header)!important;
    color:var(--enterprise-button)!important;
}

.table-actions .search-btn {
    font-size:0.9rem;
    border-radius: 6px;
    border:0px;
    border-radius: 100px;
    background: var(--icon-blue);
    margin-right:0.5rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.5rem 0.6rem;
}


/**Navbar */

   
    .location{
        border-left:1px solid var(--sidenav-link)!important;
        border-right:1px solid var(--sidenav-link)!important;
        padding:0rem 1rem;
    }


.page-nav{
        margin-top:0rem;
    }

    .breadcrumb{
        margin:0px!important;
    }

    .jobs-nav{
        background-color: var(--nav);
        border-bottom:0px;
        display:grid;
        grid-template-rows:auto auto;
        row-gap:0.7rem;
        padding:0.5rem;
        border-radius:8px;
    }

    .title{
        color:var(--page-header);
        font-family: var(--heading-font-bold);
        font-size: 1.6rem;
    }

    

     .breadcrumb-link{
            color:var(--navlink);
            text-decoration: none;
    }

    .job-details{
        display:grid;
        grid-template-rows: auto auto;
        row-gap: 0.1rem;
    }

    .sub-details{
        display: flex;
        column-gap: 1rem;
        color:var(--sidenav-link);
        font-size:0.9rem;
        font-family: var(--heading-font-regular);
    }

    

   

    nav a.router-link-exact-active {
            color: var(--navlink-active);
    }

/** Navbar */

/** Table */

/* Datatable base */
.table-content {
    overflow-x: auto;
}

#myTable {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-family, Arial, Helvetica, sans-serif);
    font-size: 14px;
    color: var(--text-color, #222);
}

#myTable thead th {
    text-align: left;
    padding: 10px 12px;
    background: var(--table-header-bg, #f7f8fa);
    color: var(--table-header-color, #111);
    border-bottom: 1px solid rgba(0,0,0,0.08);
    position: sticky;
    top: 0;
    z-index: 2;
}



#myTable tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    vertical-align: middle;
}

/* Row hover and stripe */
#myTable tbody tr:nth-child(odd) {
    background: var(--table-row-odd, #fff);
}
#myTable tbody tr:nth-child(even) {
    background: var(--table-row-even, #fbfbfb);
}
#myTable tbody tr:hover {
    background: rgba(0,0,0,0.03);
}

/** Table */
</style>